/* eslint-disable */
<template>
	<div class="perfect">
		<div class="searching" v-show="searchingShow">
			<el-form ref="sform" :model="searchingform" :rules="srules">
				<el-form-item label="请选择类型：">
					<el-radio-group v-model="searchingform.region" @change="userType">
						<el-radio label="entrepreneur">单位组织</el-radio>
						<el-radio label="personage">个人用户</el-radio>
					</el-radio-group>

					<!--<el-radio v-model="searchingform.region" label="是">是</el-radio>-->

					<!--<el-select v-model="searchingform.region" placeholder="请选择" style="width: 60%;" @change="userType">
						<el-option label="单位组织" value="entrepreneur"></el-option>
						<el-option label="个人用户" value="personage"></el-option>
					</el-select>-->

				</el-form-item>
				<transition name="el-fade-in-linear">
					<el-form-item prop="name" v-show="searchingform.region === 'entrepreneur'">
						<el-input v-model.trim="searchingform.name" type="text" style="width: 60%" placeholder="请填写组织/单位名称">
						</el-input>
						<span style="margin-left: 10px; font-size: 14px; color: #409EFF;"><i class="el-icon-edit" ></i> 请填写组织/单位名称 </span>
					</el-form-item>
				</transition>
				<transition name="el-fade-in-linear">
					<div class="token-box" v-show="safetyVerify && searchingform.region === 'entrepreneur'">
						<h1 class="tit">企业安全校验</h1>
						<el-form-item prop="account">
							<el-input v-model.trim="searchingform.account" type="text" style="" placeholder="请输入IDcode用户登录名">
							</el-input>
						</el-form-item>
						<el-form-item prop="password">
							<el-input v-model="searchingform.password" type="password" placeholder="请输入IDcode用户登录密码">
							</el-input>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="appear">验证</el-button>
						</el-form-item>
					</div>

				</transition>
				<transition name="el-fade-in-linear">
					<el-button type="primary" v-show="!safetyVerify" @click="establish">创建</el-button>
				</transition>
			</el-form>
		</div>
		<!--{{$store.state.commonalityData.platformRole}}-->
		<transition name="el-fade-in-linear">
			<div v-show="informationShow">
				<el-alert  type="error"title="审核通知"  v-show="datahint !=''" show-icon style="width: 50%;" >
				<!--<div slot="title">
					<div v-show="datahint !=''" v-html="datahint"></div>
				</div>-->
				<div  v-html="datahint"></div>
				<!--212212-->
				</el-alert>
				<!--<div class="datahint error-me-tlt" style="padding-top: 0;" v-show="datahint !=''" v-html="datahint">
				</div>-->
				<!--{{$store.state.commonalityData.platformRole}}-->
				<!--<component v-bind:is="currentTabComponent"></component>-->
				<!--{{searchingform.name}}-->
				<entrepreneur :brand="searchingform.name" ref="entrepreneur" v-if="searchingform.region === 'entrepreneur'&& $store.state.commonalityData.platformRole == 4" v-on:post='passOn($event)'></entrepreneur>

				<personage v-on:post='passOn($event)' v-else> </personage>

			</div>
		</transition>
	</div>
</template>

<script>
	//	import Entrepreneur from '@/components/information/entrepreneur.vue'
	import debounce from "lodash/debounce";
	export default {
		name: 'perfect',
		components: {
			Entrepreneur: () =>
				import('@/components/information/entrepreneur.vue'),
			Personage: () =>
				import('@/components/information/Personage.vue'),

		},
		data() {
			var examine = debounce((rule, value, callback) => {
				if(value === '') {
					callback(new Error('请填写组织/单位名称'));
					this.safetyVerify = false;

				} else {
					if(value.length <= 2 || value.length > 48) {
						callback(new Error('必须大于2小于46'));
						this.safetyVerify = false;

					} else {

						this.$http.get(this.$api + '/organUnit/validateUnitName', {
							params: {
								organUnitName: value,
								organUnitID: this.$store.state.commonalityData.IdcodeUserId || 0
							}
						}).then(res => {
							//							console.log(rule)

							if(res.body.result === 0) {
								if(this.searchingShow) {
									callback(new Error('您输入的企业名称已在IDcode平台注册，请在下面输入用户名和密码进行安全校验'));

								} else {
									callback(new Error(res.body.message));
								}
								//								
								this.safetyVerify = true;
							} else {
								this.safetyVerify = false;
								callback();
							}

						})

					}
				}
			}, 300);
			var sitePass = (rule, value, callback) => {

				if(this.form.territory != '') {
					callback();
				} else {
					if(value.province.value === '') {
						callback(new Error('请输入地址'));

					} else {

						if(this.form.resource == 'province' && value.province.value == "") {
							//          this.$refs.ruleForm.validateField('sitef');
							callback(new Error('请输入省份'));
						} else if(this.form.resource == 'city' && value.province.value == "" && value.city.value == "") {
							callback(new Error('请输入省份和市'));

						}

						callback();
					}
				}

			};

			var industryPass = (rule, value, callback) => {
				if(value.stair.present === '' && value.secondlevel.present === '') {
					callback(new Error('请输入组织/单位行业'));

				} else {

					callback();
				}
			};
			var idtypePass = (rule, value, callback) => {
				if(value.present === '') {
					callback(new Error('请选择证件类型'));

				} else {
					callback();
				}
			};
			var onePass = (rule, value, callback) => {
				if(this.form.phone != '' || this.form.mobile != '') {
					callback();
				} else {
					//					callback();
					callback(new Error('联系电话和手机号码至少填写一个'));
				}
			};
			var validatePass = (rule, value, callback) => {
				//				console.log(value)
				if(value === '') {
					callback(new Error('请输入密码'));
				} else {
					if(this.form.checkPass !== '') {
						this.$refs.form.validateField('checkPass');
					}
					callback();
				}
			};
			var validatePass2 = (rule, value, callback) => {
				if(value === '') {
					callback(new Error('请再次输入密码'));
				} else if(value !== this.form.userPassword) {
					callback(new Error('两次输入密码不一致，请重新输入，请重新输入!'));
				} else {
					callback();
				}
			};

			var registerNamePass = (rule, value, callback) => {
				this.$http.get(this.$api + '/organUnit/validateLoginName', {
					params: {
						loginName: value
					}
				}).then(res => {
					if(res.body.result === 0) {
						callback(new Error(res.body.message));

					} else {
						callback();

					}
				})
			}

			var numberVerification = (rule, value, callback) => {
				if(this.form.idtype.present === '') {
					callback(new Error('请先选择证件类型'));

				} else {
					if(value === '') {
						callback(new Error('请填写证件号码'));

					} else {

						if(this.form.idtype.present == 2) {
							if(/^[^_IOZSVa-z\W]{2}\d{6}[^_IOZSVa-z\W]{10}$/g.test(value)) {

								callback(new Error('统一社会信用代码格式不正确，请重新填写'));

							} else {

								callback();

							}
						}

					}
				}

			}

			return {
				currentTabComponent: 'Entrepreneur',
				userDataShow: false,
				datahint: '',
				migrationid: '',
				informationShow: false,
				searchingShow: true,
				searchingform: {
					region: 'entrepreneur',
					name: '',
					account: '',
					password: ''
				},

				safetyVerify: false,
				blockform: false,
				namedisabled: false,

				magnify: {
					imageUrl: '',
					logoUrl: '',
				},
				webimgurl: {},
				webimgur2: {},

				inquires: {
					parentID: 0,
					level: 1
				},
				name: '',
				activeName: 'first',
				srules: {
					name: {
						validator: examine,
						trigger: 'change'
					},
					account: [{
						required: true,
						message: '请输入IDcode平台注册用户名',
						trigger: 'blur'
					}, ],
					password: [{
						required: true,
						message: '请输入IDcode平台注册用户密码',
						trigger: 'blur'
					}, ],

				},

				expandform: {
					name: '',
					Englishname: '',
					Englishaddress: '',
					businessaddress: '',
					Englishbusinessaddress: '',
					ParsingTheAddress: '',
					scale: '',
					registered: ''
				},
				exrules: {
					registered: [{
						pattern: /^[0-9_]+$/,
						message: '格式不正确，请填写数字类型',
						trigger: 'blur'
					}]
				},
				scaleData: [],

			}

		},
		created() {
			this.$store.commit('userGuard', false)
			if(this.$store.state.commonalityData.IdcodeUserId) {
				this.homecourt2();
				//							this.$http.get(this.$api + '/organUnit/getUnitInfoByID', {
				//								params: {
				//									unitID: this.$store.state.commonalityData.IdcodeUserId
				//								}
				//							}).then(res => {
				//			
				//								this.datafill(res);
				//							})
			} else {
				this.homecourt();
			}
			this.userDataShow = false;
		},
		mounted() {

		},
		watch: {},
		methods: {
			passOn(context) {
				this.datahint = context;
			},
			//			onSubmit(formName) {
			//				let registeredNuber;
			//				this.$refs.expandform.validateField('registered', (error) => {
			//					if(!error) {
			//						registeredNuber = true;
			//					} else {
			//						registeredNuber = false;
			//						return false;
			//
			//					}
			//				})
			//				this.$refs[formName].validate((valid) => {
			//					if(valid && registeredNuber) {
			//						let {
			//							form,
			//							expandform
			//						} = this;
			//						this.$http.post(this.$api + '/organUnit/saveUnitInfo', {
			//							organunit_id: form.id || 0,
			//							organunitname: this.form.name,
			//							organunitnameen: expandform.Englishname,
			//							province_id: this.form.site.province.value,
			//							city_id: this.form.site.city.value,
			//							area_id: this.form.site.district.value,
			//							unittypedisplay_id: this.form.nature,
			//							trade_id: this.form.industry.secondlevel.present,
			//							organunitaddress: form.desc,
			//							organunitaddressen: expandform.Englishaddress,
			//							unitworkaddress: expandform.businessaddress,
			//							unitworkaddressen: expandform.Englishbusinessaddress,
			//							email: form.mailbox,
			//							organunitlevel: this.form.intention,
			//							linkman: form.linkman,
			//							fax: form.phone,
			//							linkphone: form.mobile,
			//							codepaytype: form.idtype.present,
			//							organizationcode: form.Unifiedsocialcredit,
			//							organunitlicense: form.imageUrl,
			//
			//							//							this.webimgurl.imageBig===undefined?'': this.webimgurl.imageBig + '|' + this.webimgurl.imageSmall,
			//							uniticon: form.logoUrl,
			//							//							this.webimgur2.imageBig === undefined?'':  this.webimgur2.imageBig + '|' + this.webimgur2.imageSmall,
			//							gotourl: expandform.ParsingTheAddress,
			//							unitsizetype_id: expandform.scale || 3,
			//							registeredcapital: expandform.registered || -1,
			//							loginName: form.registerName, //用户名
			//							loginPwd: form.userPasswordTwo, //用户名							
			//
			//						}).then(res => {
			//							//							console.log(res)
			//							if(res.body.result === 1) {
			//								this.$message({
			//									message: '提交修改成功',
			//									type: 'success'
			//								});
			//								//store,cookie更新	
			//								this.$store.state.commonalityData.IdcodeUserId = res.body.entity.organunit_id;
			//								this.$store.state.commonalityData.name = res.body.entity.organunitname;
			//
			//								var yang = JSON.stringify(res.body.entity);
			//								this.$setCookie('Data', escape(yang));
			//
			//								this.$router.push('/')
			//
			//							} else {
			//								this.$message.error(res.body.message + '请尝试重新提交');
			//							}
			//						}, res => {
			//							this.$message.error('提交错误，请尝试重新提交');
			//
			//						})
			//
			//					} else {
			//						//						console.log('error submit!!');
			//						return false;
			//					}
			//				});
			//
			//			},
			appear({
				name,
				account,
				password
			}) {

				//				this.$refs.sform.validateField((valid) => {

				//					 if (valid) {
				this.$http.get(this.$api + '/organUnit/getUnitInfoByName', {
					params: {
						organUnitName: this.searchingform.name || name,
						loginName: this.searchingform.account || account,
						loginPwd: this.searchingform.password || password
					}
				}).then(res => {
					this.datafill(res);
				})

			},

			datafill(res) {
				if(res.body.result === 1) {
					this.homecourt2();
					//					console.log(this.searchingShow)
					let {
						form,
						expandform,
						//						blockform,
						//						namedisabled
					} = this.$refs.entrepreneur
					let {
						organUnit,
						organUnitArea,
						trade_parent_id,
						organUnitTrade,
						isDisabled,
						unitNameIsEdit,
						selectNature,
						messageTip
					} = res.body.entity;
					//						权限控制
					this.$refs.entrepreneur.blockform = isDisabled === 0 ? false : true;
					this.$refs.entrepreneur.namedisabled = unitNameIsEdit === 0 ? false : true;
					//					unitNameIsEdit === 0 ? false : true;
					//                   基础数据
					if(trade_parent_id != -100) {
						//						this.IndustryGroup(trade_parent_id)
						this.industryData({
							id: trade_parent_id
						}).then(res => {
							form.industry.secondlevel.data = res.body.entity.map((item, index) => {
								return {
									value: item.tradeId,
									label: item.tradename
								}
							})
						})
					}

					//						赋值

					form.name = organUnit.organunitname;
					form.id = String(organUnit.organunit_id_str);
					form.intention = organUnit.organunitlevel;
					form.mailbox = organUnit.email;
					form.desc = organUnit.organunitaddress;
					form.linkman = organUnit.linkman //联系人
					form.phone = organUnit.fax //联系电话
					form.industry.stair.present = trade_parent_id === -100 ? '' : trade_parent_id;

					form.industry.secondlevel.present = organUnit.trade_id === -100 ? '' : organUnit.trade_id;
					this.datahint = messageTip;
					expandform.Englishname = organUnit.organunitnameen;

					expandform.Englishaddress = organUnit.organunitaddressen;
					expandform.businessaddress = organUnit.unitworkaddress;
					expandform.Englishbusinessaddress = organUnit.organunitaddressen;
					expandform.ParsingTheAddress = organUnit.gotourl; //单位解析地址
					expandform.scale = organUnit.unitsizetype_id; //单位规模
					expandform.registered = organUnit.registeredcapital < 0 ? 0 : organUnit.registeredcapital;
					//单位注册资金
					form.mobile = organUnit.linkphone //联系人手机
					form.idtype.present = organUnit.codepaytype //证件类型
					form.Unifiedsocialcredit = organUnit.organizationcode //证件号码
					form.imageUrl = organUnit.organunitlicense //营业执照
					//						console.log(form.imageUrl)
					form.logoUrl = organUnit.uniticon === null ? '' : organUnit.uniticon //单位Logo
					form.territory = organUnitArea;
					form.nature = selectNature;
				} else {
					this.$message.error(res.body.message);
					this.searchingform.password = '';
					this.$refs.sform.validateField('password');

				}
			},
			industryData({
				id
			}) {
				return this.$http.get(this.$api + '/baseData/getTradeList', {
					params: {
						parentID: id
					}
				})
			},
			IndustryGroup(id) {
				this.industryData({
					id: id
				}).then(res => {

					this.form.industry.secondlevel.data = res.body.entity.map((item, index) => {
						return {
							value: item.tradeId,
							label: item.tradename
						}
					})
					this.form.industry.secondlevel.present = this.form.industry.secondlevel.data[0].value;
				})

			},
			homecourt() {
				this.searchingShow = true;
				this.informationShow = false;
			},
			homecourt2() {
				this.searchingShow = false;
				this.informationShow = true;
			},
			establish() {
				if(this.searchingform.region === 'entrepreneur') {
					if(this.searchingform.name === '' || this.searchingform.name.length <= 2 || this.searchingform.name.length >= 48) {
						this.$refs.sform.validateField('name')
					} else {
						this.$store.commit('userGuard', true)
						this.homecourt2();
						this.$refs.entrepreneur.namedisabled = true;
					}
				} else {
					this.$store.commit('userGuard', true)
					this.homecourt2();
					//					this.$refs.entrepreneur.namedisabled = true;
				}

			},
			userType(val) {
				this.searchingform.name = '';
				this.$store.state.commonalityData.platformRole = val === "entrepreneur" ? 4 : 5
				//				let {
				//					commonalityData
				//				} = this.$store.state;
				//				this.safetyVerify = false;
				//				commonalityData.platformRole = val === "entrepreneur" ? 4 : 5
				//				this.$store.dispatch('DataUpdate', commonalityData)

				console.log(this.$store.state.commonalityData.platformRole)

			}
		}
	}
</script>
<style lang="scss">
	.perfect {
		padding: 0 0 116px 0;
		text-align: center;
		/*border: solid red 1px;*/
		text-align: left;
		.formbox {
			/*border: solid red 1px;*/
			padding: 0 20px;
			width: 100%;
			.context-fl {
				width: 60%;
				/*border: solid red 1px;*/
			}
			.f-fr {
				width: 40%;
			}
			/*margin: 0 auto;*/
		}
	}
	
	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}
	
	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}
	
	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 178px;
		height: 178px;
		line-height: 178px;
		text-align: center;
	}
	
	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}
	
	.searching {
		/*border: solid red 1px;*/
		width: 500px;
		margin: 0 auto;
		margin-top: 10%;
		padding: 20px 0;
		.tit {
			font-size: 15px;
			padding: 10px 0;
			font-weight: 500;
			color: #333333;
			text-align: center;
		}
		.token-box {
			margin-top: 20px;
		}
		.gist {
			.assist {
				font-size: 14px;
				color: #333333;
				margin-left: 10px;
				/*border: solid red 1px;*/
			}
		}
	}
	
	.perfect {}
	
	.extend {
		padding: 20px 0;
		/*border: solid red 1px;*/
		width: 60%;
	}
	
	.datahint {
		/*text-align: left;
		padding-left: ;
		
		font-size: 14px;*/
		padding-left: 20px;
	}
	
	.custom-label {
		&::before {
			content: '*';
			color: #F56C6C;
			margin-right: 4px;
		}
	}
</style>